let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("566Wk")).then(() => parcelRequire('4OWnt'));